import { useAccommodationPlaceHotels } from './useAccommodationPlaceHotels';
import { AccommodationPlaces, UseAccommodationsConsoleListingsArgs } from '@apps/accommodations/AccommodationsConsole.types';
import { useRegionalHotels } from './useRegionalHotels';

export const useCombinedHotels = (variant: 'couple' | 'regional', args: UseAccommodationsConsoleListingsArgs, accommodationPlaces?: AccommodationPlaces) => {
  const { cachedListings, listings, isFetchingListings, error } = useAccommodationPlaceHotels(accommodationPlaces);
  const { cachedListings: regionalCachedListings, listings: regionalListings, isFetchingListings: isFetchingRegionalListings, error: regionalError } = useRegionalHotels(
    args,
    accommodationPlaces
  );

  return {
    cachedListings: variant === 'couple' ? cachedListings : regionalCachedListings,
    listings: variant === 'couple' ? listings : regionalListings,
    isFetchingListings: isFetchingListings || isFetchingRegionalListings,
    error: error || regionalError
  };
};
